(function(){'use strict';function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}function parseJSON(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};try{return JSON.parse(e)}catch(e){return t}}var initializedSections=new WeakSet;function initRecentlyBoughtSection(e){var t=e.querySelector("[data-recently-bought-track]");if(t&&"function"==typeof window.Flickity){var i=Number(e.dataset.productsCount||0),n=Number(e.dataset.mobileThreshold||1),o=Number(e.dataset.desktopThreshold||3),a=parseJSON(e.dataset.flickityOptions,{}),c=window.matchMedia("(max-width: 749px)"),r=null,s=null,d=function(){(c.matches?i>n:i>o)?(e.classList.add("is-slider-enabled"),r?r.resize():r=new window.Flickity(t,_objectSpread2({},a))):(e.classList.remove("is-slider-enabled"),r&&(r.destroy(),r=null));};d(),e.classList.remove("recently-bought--pre-init"),window.addEventListener("resize",(function(){clearTimeout(s),s=setTimeout(d,150);}));}}function initRecentlyBoughtSections(){document.querySelectorAll("[data-recently-bought-section]").forEach((function(e){initializedSections.has(e)||(initializedSections.add(e),initRecentlyBoughtSection(e));}));}document.addEventListener("DOMContentLoaded",initRecentlyBoughtSections),document.addEventListener("shopify:section:load",initRecentlyBoughtSections);})();